function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState } from 'react';
import cn from 'classnames';
import { Link, browserHistory } from 'react-router';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { countSelectedSubcategories, getWholeSubcategoriesForMobile, singleLinks } from 'swag-client-common/utils/mobile-menu.utils';
import ConfigurableLink from 'swag-client-common/components/utils/configurable-link';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import classes from '../side-menu.scss';
const Category = _ref => {
  let {
      updatedCategory: {
        subcategories
      },
      useHardLinks,
      isHighlightCategory,
      initState,
      selectedCategoryIds,
      hideMenu,
      routeNavigationConfirmation,
      onClearFilters,
      gotoAllSwag
    } = _ref,
    parentCategory = _objectWithoutProperties(_ref.updatedCategory, ["subcategories"]);
  const [isShown, toggle] = useState(initState);
  const wholeSubcategories = getWholeSubcategoriesForMobile(parentCategory, subcategories);
  const handleCategoryClick = () => {
    if (singleLinks[0] === parentCategory.slug) {
      hideMenu();
      return gotoAllSwag();
    } else if (singleLinks[1] === parentCategory.slug) {
      parentCategory.slug && browserHistory.push(`${APP_ROUTES.COLLECTIONS}/${parentCategory.slug}`);
      hideMenu();
    } else {
      toggle(prevState => !prevState);
    }
  };
  const onSubClick = index => {
    if (!index && countSelectedSubcategories(wholeSubcategories, selectedCategoryIds) > 1) {
      onClearFilters();
    }
    toggle(prev => !prev);
    hideMenu();
  };
  const renderIcon = () => subcategories && subcategories.length > 0 ? isShown ? /*#__PURE__*/React.createElement(RemoveIcon, {
    className: classes.forwardIcon
  }) : /*#__PURE__*/React.createElement(AddIcon, {
    className: classes.forwardIcon
  }) : null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
    onClick: handleCategoryClick,
    to: "",
    className: cn({
      [classes.isSelected]: isHighlightCategory
    })
  }, parentCategory.name || parentCategory.text, renderIcon()), /*#__PURE__*/React.createElement("div", {
    className: cn(classes.column, classes.indent, {
      [classes.hide]: !isShown
    })
  }, wholeSubcategories.map((subcategory, i) => /*#__PURE__*/React.createElement(ConfigurableLink, {
    key: subcategory._id,
    onClick: () => onSubClick(i),
    className: cn({
      [classes.isSelected]: subcategory.isHighlightSubCategory
    }),
    routeNavigationConfirmation: routeNavigationConfirmation,
    isHardLink: useHardLinks && !routeNavigationConfirmation,
    link: `${APP_ROUTES.COLLECTIONS}/${subcategory.slug}`
  }, subcategory.name))));
};
export default Category;